<div>
  <!-- Show existing files if any / or selected file -->
  @if ((existingFiles()?.length ?? 0) > 0) {
    <div class="bn-upload-files__selected-files text-start ps-2 pe-0 pt-2 pb-4">
      @for (file of existingFiles(); let fileId = $index; track file.url) {
        <div class="row mb-1 align-items-center">
          <div class="col-8 bn-upload-files__selected-files__item d-flex gap-1 align-items-center border-radius-md p-0">
            <div class="bn-upload-files__selected-files__icon border-radius-sm mr-1 d-inline-block col-auto">
              @if (file.icon) {
                <fa-icon [icon]="file.icon" />
              } @else {
                <fa-icon icon="file-lines" />
              }
            </div>
            <div class="bn-upload-files__selected-files__meta flex-grow-1 d-inline-block">
              <div
                class="bn-upload-files__selected-files__name text-100-semi-bold color-dark-8 text-nowrap"
                [title]="file.title">
                {{ file.title }}
              </div>
            </div>
            @if (file.size) {
              <div class="text-100-regular text-nowrap">
                {{ (file.size | formatByte).formatted }}
              </div>
            }
            @if (!isDisabled()) {
              <div
                class="bn-upload-files__selected-files__delete border-radius-sm d-inline-block"
                data-e2e="WebUiUploadFileRemove"
                (click)="onRemoveExistingFile(file.id)"
                (keyPress)="onRemoveExistingFile(file.id)">
                <fa-icon icon="xmark" />
              </div>
            }
          </div>
          <div class="col-auto ms-auto">
            <button
              bn-web-ui-button
              class="w-100 text-dark-7"
              data-e2e="ThumbnailPreviewButton"
              itemStyle="stroke"
              leftIcon="eye"
              size="md"
              [disabled]="!file.url"
              [lessPadding]="true"
              [noEllipsis]="true"
              (click)="file.url && onShowPreview(file.url)"
              (keyPress)="file.url && onShowPreview(file.url)">
              Preview
            </button>
          </div>
        </div>
      }
    </div>
  }
  <form [formGroup]="form">
    @if (label()) {
      <div class="bn-form__label">
        {{ label() }}
        @if (isRequired) {
          <span
            class="bn-form__required-mark"
            tooltip="Required field"
            >*</span
          >
        }
      </div>
    }
    <p class="bn-form__description bn-form__description--before"><ng-content /></p>
    <label
      class="w-100 bn-upload-files {{ itemStyle ? 'bn-upload-files--' + itemStyle : '' }}"
      [ngClass]="{
        'bn-upload-files--drag-over': isDraggedOver,
        'bn-upload-files--success': success,
        'bn-upload-files--error': error,
        'bn-upload-files--disabled': isDisabled(),
        'bn-upload-files--label': label()?.length,
      }"
      (dragleave)="onDragLeave($event)"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)">
      @if (title()) {
        <div class="bn-upload-files__title text-400-medium text-dark-8">
          {{ title() }}
        </div>
      }
      <input
        class="bn-upload-files__input"
        formControlName="fileInput"
        type="file"
        [attr.accept]="allowedFileTypes ? '.' + allowedFileTypes.join(',.') : undefined"
        [attr.multiple]="isMultiple"
        (blur)="onTouch()"
        (change)="onUpload($event)"
        (click)="onClick()" />
      <span class="bn-upload-files__button">
        <button
          bn-web-ui-button
          class="text-dark-7"
          itemStyle="stroke"
          leftIcon="file-lines"
          size="xl"
          [disabled]="isDisabled()"
          [loading]="isLoading()">
          {{ buttonText() }}
        </button>
      </span>
      @if (browseLinkText()) {
        <p class="bn-upload-files__browse">
          <a class="bn-upload-files__browse__link">{{ browseLinkText() }}</a>
        </p>
      }
      @if (allowedFileTypes?.length && showAllowedFileTypesLabel()) {
        <p class="bn-upload-files__supported">
          Supported:
          @for (allowedFileType of allowedFileTypes; let fileId = $index; track fileId) {
            <span>{{ fileId !== 0 ? ', ' : '' }}{{ allowedFileType }}</span>
          }
          @if (allowedFileTypesLabel()) {
            <div class="mt-1">
              <span>{{ allowedFileTypesLabel() }}</span>
            </div>
          }
        </p>
      }
      @if (showUploadedFiles) {
        <div class="bn-upload-files__selected-files text-start mx-2">
          @for (file of files; let fileId = $index; track files[fileId].file.name) {
            @let meta = file.file;
            <div class="bn-upload-files__selected-files__item border-radius-md mb-1">
              <div class="bn-upload-files__selected-files__icon border-radius-sm mr-2 d-inline-block">
                <fa-icon [icon]="file.icon" />
              </div>
              <div class="bn-upload-files__selected-files__meta flex-grow-1 d-inline-block">
                <div
                  class="bn-upload-files__selected-files__name text-100-bold"
                  [title]="meta.name">
                  {{ meta.name }}
                </div>
                <div class="text-100-regular">{{ (meta.size | formatByte).value }} {{ (meta.size | formatByte).unit }}</div>
              </div>
              <div
                class="bn-upload-files__selected-files__delete border-radius-sm mr-2 d-inline-block"
                (click)="onRemoveFile($event, fileId)"
                (keyPress)="onRemoveFile($event, fileId)">
                <fa-icon icon="xmark" />
              </div>
            </div>
          }
        </div>
      }
    </label>
    <bn-web-ui-formcontrol-errors
      [control]="ngControl.control"
      [customError]="customError" />
  </form>
</div>
